<template>
  <v-container fluid tag="section">
      <base-material-dialog
        title='专利编辑'
        :dialog="item.show"
        v-bind="$attrs"
        @on-dialog-change='dialogChange'
        max-width='400'
        persistent
      >
        <template v-slot:content>
          <v-card class="px-3" elevation="0">
            <v-form ref="form" lazy-validation>
              <v-card-text>
                <v-row>
                  <v-col cols="12" md="12">
                    <v-text-field hide-details="auto" label="年费年度(目前维护年度，非待缴费年度)" outlined :rules="number" placeholder="目前年费维护年度" v-model="form.yearCostNumber"></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" md="12">
                    <base-material-date
                      ref='date'
                      :rules="required"
                      hide-details='auto'
                      outlined
                      label='受理时间'
                      clear-icon="mdi-close-circle-outline"
                      v-model='form.acceptTimeStr'
                    >
                    </base-material-date>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-form>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text class="text--disabled" @click='item.show = false'>
                关闭
              </v-btn>
              <v-btn color="primary" :loading="loading" @click='save'>
                保存
              </v-btn>
            </v-card-actions>
          </v-card>
        </template>
    </base-material-dialog>
  </v-container>
</template>

<script>
  import { edit } from '@/api/patent/index.js'

  export default {
    name: 'PatentYearEdit',
    components: {
    },
    props: {
      item: {
        type: Object,
        default: () => ({
          show: false,
          data: null
        })
      }
    },
    data() {
      return {
        loading: false,
        required: [
          value => !!value || '此项为必填项!'
        ],
        number: [
          value => !!value || '此项为必填项!',
          value => /^[1-9]+.?[1-9]*$/.test(value) || '必须输入数字',
        ],
        form: {
          id: '',
          yearCostNumber: '',
          acceptTime: '',
          acceptTimeStr: ''
        },
        defForm: {
          id: '',
          yearCostNumber: '',
          acceptTime: '',
          acceptTimeStr: ''
        }
      }
    },
    methods: {
      save () {
        if (this.$refs.form.validate()) {
          this.form.acceptTime = new Date(this.form.acceptTimeStr).getTime() / 1000
          this.loading = true
          edit(this.form).then(res => {
            if (res.status === 200) {
              this.item.show = false
              this.$emit("on-load-data")
              this.$dialog.notify.success('操作成功', { position: 'top-right', timeout: 4000 })
            }
            this.loading = false
          })
        }
      },
      dialogChange (val) {
        this.item.show = val
        if (val) {
          this.form.id = this.item.data.id
          this.form.yearCostNumber = this.item.data.yearCostNumber
          this.form.acceptTime = this.item.data.acceptTime
          this.form.acceptTimeStr = this.item.data.acceptTimeStr
        } else {
          this.form = JSON.parse(JSON.stringify(this.defForm))
        }
      }
    }
  }
</script>

<style lang="sass">
  #system-user-detail-page
</style>
